<template>
  <VcConfirmModal :show-dialog="show"
                  size="sm"
                  :useOffset="false"
                  :title="texts.title"
                  :content-text="texts.content"
                  :okButtonLabel="texts.okBtn"
                  :wrap-title="true"
                  @onCloseButtonClicked="$emit('onCloseButtonClicked')"
                  @onCancelClicked="$emit('onCancelClicked')"
                  @onOkClicked="$emit('onOkClicked')"/>
</template>

<script>
export default {
  name: "UnsavedChangesConfirmation",
  props: {
    show: {
      type: Boolean,
      required: true
    },
    subject: {
      type: String,
      required: true
    }
  },
  computed: {
    texts() {
      switch (this.subject) {
        case 'automation':
          return {
            title: this.$t('campaign.preference_dialog.discard_automation'),
            content: this.$t('campaign.preference_dialog.discard_text'),
            okBtn: this.$t('campaign.preference_dialog.discard')
          }
        default:
          return {
            title: this.$t('common.actions.unsaved_changes_title'),
            content: this.$t('common.actions.unsaved')
          }
      }
    }
  }
}
</script>
